//import axios from "axios";
// import Swiper core and required modules
import { Navigation, Pagination, Lazy, A11y, Zoom } from 'swiper';
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
import cartOptions from '../../coto_scripts/cart/cart-slide';
import ReviewStars from '../yotpo-reviews/review-stars/review-stars.vue';
import { colorways } from '../mixins/colorways';
import { size } from '../mixins/size';
import { pdp } from '../mixins/pdp';
import { cloudinary } from '../mixins/cloudinary';
import { dynamicYieldEvent } from '../mixins/dynamicYieldEvent';
import pdpError from './pdp-error/pdp-err.vue';
import loadingAnimation from '../loading-animation.vue';
import { useMobile } from '../composables/useMobile';
import sizechart from '../pdp/sizechart/sizechart.vue';

export default {
  name: 'pdpStandard',
  components: {
    Swiper,
    SwiperSlide,
    ReviewStars,
    pdpError,
    loadingAnimation,
    sizechart,
  },
  mixins: [colorways, size, pdp, dynamicYieldEvent, cloudinary],
  props: ['productId', 'abVersion', 'productIdForReviews', 'picLimit'],
  setup() {
    const onSwiper = (swiper) => {};
    const onSlideChange = () => {};
    const { isMobile } = useMobile();
    return {
      isMobile,
      pagination: {
        clickable: true,
      },
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Lazy, A11y, Zoom],
    };
  },
  data() {
    return {
      oosMobileRef: null,
      mobileRef: null,
      oosModalRef: null,
      modalRef: null,
      accordionContent: [],
      whyYoullLoveIt: '',
      numReviews: 0,
      avgReview: 0,
      isActive: false,
      showModal: false,
      showVidmodal: false,
      showSizemodal: false,
      isInViewPort: false,
      activeDrawer: 0,
      isDrawerOpen: false,
      modelInfo: '',
      displayedModels: [],
      ddRelativeLink: '',
      selectedColor: { name: '', price: 0 },
      selectedSize: { name: '', available: 0 },
      selectedGroup: 0,
      selectedVariantID: null,
      initialLoadError: false,
      colorwaysWithInventory: [],
      product: {},
      selectedVariant: {},
      dynamicYieldCartObject: [],
      isDonationOrGiftCard: false,
      selectedVariantPrice: 0,
      hideSizeGuide: false,
      error: false,
      loading: true,
      uptContentWell: null,
      uptHandle: '',
      isGiftCard: false,
      email: '',
      product_id: '',
      emailError: 'Email aint valid',
      formSubmitted: false, // Track if the form has been submitted
      validSubmit: false,
      modelInfoMap: {
        // MEN
        'Model Jeremy': {
          name: 'Jeremy',
          height: '6\'0"',
          sizeDefault: 'medium',
          sizeNumerical: '32',
        },
        'Model Mario': {
          name: 'Mario',
          height: '5\'9"',
          sizeDefault: 'medium',
          sizeNumerical: '32',
        },
        'Model Kirk': {
          name: 'Kirk',
          height: '6\'0"',
          sizeDefault: 'medium',
          sizeNumerical: '32',
        },
        'Model Elvis': {
          name: 'Elvis',
          height: '6\'1"',
          sizeDefault: 'medium',
          sizeNumerical: '32',
        },
        'Model Vincent': {
          name: 'Vincent',
          height: '6\'1"',
          sizeDefault: 'medium',
          sizeNumerical: '32',
        },
        'Model Xavier': {
          name: 'Xavier',
          height: '5\'11"',
          sizeDefault: 'medium',
          sizeNumerical: '32',
        },
        'Model Munther': {
          name: 'Munther',
          height: '6\'2"',
          sizeDefault: 'medium',
          sizeNumerical: '32',
        },
        'Model Jason': {
          name: 'Jason',
          height: '5\'11"',
          sizeDefault: 'medium',
          sizeNumerical: '32',
        },
        'Model Alex': {
          name: 'Alex',
          height: '6\'2"',
          sizeDefault: 'medium',
          sizeNumerical: '32',
        },
        'Model Kellan': {
          name: 'Kellan',
          height: '6\'1"',
          sizeDefault: 'medium',
          sizeNumerical: '32',
        },
        'Model Justin': {
          name: 'Justin',
          height: '5\'11"',
          sizeDefault: 'medium',
          sizeNumerical: '32',
        },
        'Model Nicolas': {
          name: 'Nicolas',
          height: '6\'0"',
          sizeDefault: 'medium',
          sizeNumerical: '32',
        },
        'Model Ty': {
          name: 'Ty',
          height: '5\'10"',
          sizeDefault: 'medium',
          sizeNumerical: '32',
        },
        'Model Maxwell': {
          name: 'Maxwell',
          height: '6\'0"',
          sizeDefault: 'medium',
          sizeNumerical: '32',
        },
        'Model Jackson': {
          name: 'Jackson',
          height: '6\'2"',
          sizeDefault: 'medium',
          sizeNumerical: '32',
        },
        'Model Bailey': {
          name: 'Bailey',
          height: '6\'2"',
          sizeDefault: 'medium',
          sizeNumerical: '32',
        },
        // WOMEN
        'Model Sydney': {
          name: 'Sydney',
          height: '5\'9"',
          sizeDefault: 'small',
          sizeNumerical: '6',
        },
        'Model Kathleen': {
          name: 'Kathleen',
          height: '5\'10"',
          sizeDefault: 'small',
          sizeNumerical: '6',
        },
        'Model Caitlyn': {
          name: 'Caitlyn',
          height: '5\'6"',
          sizeDefault: 'small',
          sizeNumerical: '6',
        },
        'Model Jade': {
          name: 'Jade',
          height: '5\'8"',
          sizeDefault: 'small',
          sizeNumerical: '6',
        },
        'Model Nadine': {
          name: 'Nadine',
          height: '5\'5"',
          sizeDefault: 'small',
          sizeNumerical: '6',
        },
        'Model Magdalena': {
          name: 'Magdalena',
          height: '5\'9"',
          sizeDefault: 'small',
          sizeNumerical: '6',
        },
        'Model Callie': {
          name: 'Callie',
          height: '5\'9"',
          sizeDefault: 'small',
          sizeNumerical: '6',
        },
        'Model Aya': {
          name: 'Aya',
          height: '5\'7"',
          sizeDefault: 'small',
          sizeNumerical: '6',
        },
        'Model Camille': {
          name: 'Camille',
          height: '5\'10"',
          sizeDefault: 'small',
          sizeNumerical: null,
        },
        'Model Alexa': {
          name: 'Alexa',
          height: '5\'9"',
          sizeDefault: 'small',
          sizeNumerical: null,
        },
        'Model Brenna': {
          name: 'Brenna',
          height: '5\'10"',
          sizeDefault: 'small',
          sizeNumerical: null,
        },
        'Model Maile': {
          name: 'Maile',
          height: '5\'9"',
          sizeDefault: 'small',
          sizeNumerical: '6',
        },
        'Model Courtney': {
          name: 'Courtney',
          height: '5\'8"',
          sizeDefault: 'small',
          sizeNumerical: '6',
        },
        'Model London': {
          name: 'London',
          height: '5\'8"',
          sizeDefault: 'small',
          sizeNumerical: '6',
        },
        // PLUS SIZE
        'Model Jennifer': {
          name: 'Jennifer',
          height: '5\'10"',
          sizeDefault: '1X',
          sizeNumerical: null,
        },
        'Model Brianna': {
          name: 'Brianna',
          height: '6\'0"',
          sizeDefault: '1X',
          sizeNumerical: null,
        },
        'Model Amelia': {
          name: 'Amelia',
          height: '5\'9"',
          sizeDefault: '1X',
          sizeNumerical: null,
        },
        'Model Nicole': {
          name: 'Nicole',
          height: '5\'10"',
          sizeDefault: '1X',
          sizeNumerical: null,
        },
        'Model Tinola': {
          name: 'Tinola',
          height: '5\'10"',
          sizeDefault: '1X',
          sizeNumerical: null,
        },
        // KIDS
        'Model Isaiah': {
          name: 'Isaiah',
          height: '11 years old, 4\'8"',
          sizeDefault: 'medium',
          sizeNumerical: null,
        },
        'Model Dax': {
          name: 'Dax',
          height: '11 years old, 4\'9"',
          sizeDefault: 'medium',
          sizeNumerical: null,
        },
        'Model Adelina': {
          name: 'Adelina',
          height: '11 years old, 5\'0"',
          sizeDefault: 'medium',
          sizeNumerical: null,
        },
        'Model Scarlett': {
          name: 'Scarlett',
          height: '9 years old, 4\'9"',
          sizeDefault: 'medium',
          sizeNumerical: null,
        },
        'Model Gemma': {
          name: 'Gemma Nye',
          height: '12 years old, 4\'6"',
          sizeDefault: 'medium',
          sizeNumerical: null,
        },
        'Model Maliyah': {
          name: 'Maliyah',
          height: '10 years old, 4\'9"',
          sizeDefault: 'medium',
          sizeNumerical: null,
        },
      }, // Track if the form has been successfully submitted
    };
  },
  computed: {
    sizeFullName() {
      switch (this.selectedSize.name.toLowerCase()) {
        case 'xxs':
          return '2X Small';
          break;
        case 'xs':
          return 'X Small';
          break;
        case 's':
          return 'Small';
          break;
        case 'm':
          return 'Medium';
          break;
        case 'l':
          return 'Large';
          break;
        case 'xl':
          return 'X Large';
          break;
        case 'xxl':
          return '2X Large';
          break;
        case 'xxxl':
          return '3X Large';
          break;
        default:
          return this.selectedSize.name;
          break;
      }
    },
    outOfStock() {
      return this.colorwaysWithInventory.length < 1;
    },

    selectedColorImages() {
      if (this.selectedColor.images) {
        //remove bundle images from allpa products
        let nonBundleColorImages = this.selectedColor.images.filter((img) =>
          this.bundleImages(img)
        );
        //set photo limit to 8
        //if we have more than 8 here, we will use the first 8 photos.
        let photolimit =
          nonBundleColorImages.length > this.picLimit
            ? this.picLimit
            : nonBundleColorImages.length;
        return nonBundleColorImages.slice(0, photolimit);
      } else {
        return [];
      }
    },
    productImages() {
      if (this.product.images && this.selectedColor.images) {
        let nonBundleProductImages = this.selectedColor.images.filter((img) =>
          this.bundleImages(img)
        );

        //if we have more than 8 selected color photos, we won't use any product photos.
        let photolimit =
          nonBundleProductImages.length > this.picLimit
            ? 0
            : this.picLimit - nonBundleProductImages.length;
        if (photolimit <= 0) {
          return [];
        } else {
          return this.product.images
            .filter((img) => this.bundleImages(img))
            .slice(0, photolimit);
        }
      } else {
        return [];
      }
    },
    isFormValid() {
      this.validateEmail(); // Validate on form submission
      return this.email && !this.emailError;
    },
  },
  methods: {
    //screen resize
    // onResize() {
    //   this.isMobile = window.innerWidth <= 768;
    // },
    //activate the accordion drawer
    activateAccordion(drawer) {
      // if this drawer is already open, close it
      if (this.activeDrawer === drawer) {
        this.activeDrawer = null;
      } else {
        // otherwise, open the drawer
        this.activeDrawer = drawer;
      }
    },
    //toggles locally widget accordion open and closed
    // openLocally() {
    //   this.locallyOpen = !this.locallyOpen;
    // },

    // check if the product has bundle in the name before filtering out bundle imagery
    bundleImages(img) {
      if (!this.product.title.toLowerCase().includes('bundle')) {
        return !img.alt.toLowerCase().includes('bundle');
      } else {
        return true;
      }
    },

    // if tag exists
    tagExists(needle, haystack) {
      if (haystack.includes(needle)) {
        return true;
      }
      return false;
    },

    // scroll to image
    scrollToImage(img) {
      document.querySelector(img).scrollIntoView(false);
    },

    //initialize carousel
    //onInitCarousel() {},
    setSwiperRef(swiper, refname) {
      if (refname == 'mobileRef') {
        this.mobileRef = swiper;
      } else if (refname == 'oosMobileRef') {
        this.oosMobileRef = swiper;
      } else if (refname == 'modalRef') {
        this.modalRef = swiper;
      } else if (refname == 'oosModalRef') {
        this.oosModalRef = swiper;
      }
    },
    slideSwipers(img) {
      if (this.oosMobileRef) {
        // for some reason the out of stock swipers weren't working without the second parameter
        this.oosMobileRef.slideTo(img, 500);
      }
      if (this.oosModalRef) {
        this.oosModalRef.slideTo(img, 500);
      }
      if (this.mobileRef) {
        this.mobileRef.slideTo(img, 500);
      }
      if (this.modalRef) {
        this.modalRef.slideTo(img, 500);
      }
    },
    //open Modal
    openModal(img) {
      // go to image before showing the modal, to avoid wrong image flashing at first
      //this.$refs.carousel.goTo(img);
      this.slideSwipers(img);
      // go to correct image
      this.showModal = true;
    },

    //open Modal
    openVidmodal() {
      this.showVidmodal = true;
    },
    //---- Switch the group
    switchGroup(group) {
      this.selectedGroup = group;
    },

    //---- SCROLL TO TOP OF PAGE
    scrollToTop() {
      const topOfPage = document.getElementById('pdpImagesA');
      window.scrollTo({
        top: topOfPage,
        left: 0,
        behavior: 'smooth',
      });
    },

    //---- UPDATE MODEL INFO
    isFirstModelImage(alt, index) {
      return this.getIndexOfFirstModelImage(alt) === index;
    },
    getIndexOfFirstModelImage(alt) {
      return this.selectedColorImages.findIndex((sc) => sc.alt === alt);
    },

    //Model Info
    getModelInfo(firstalt) {
      // Check if the product is Coraje or Ambato
      const prodTitle = this.product.title.toLowerCase();
      //Numerical Products
      const coraje = 'coraje tech pant';
      const numericalProd =
        prodTitle.toLowerCase().includes(coraje) ||
        prodTitle.includes('ambato');

      // Iterate through the modelInfoMap
      for (let model in this.modelInfoMap) {
        if (firstalt.includes(model)) {
          const modelData = this.modelInfoMap[model];

          // Construct the text dynamically
          const size =
            numericalProd && modelData.sizeNumerical
              ? modelData.sizeNumerical
              : modelData.sizeDefault;

          return `${modelData.name} is ${modelData.height} and is wearing size ${size}.`;
        }
      }

      return ''; // If no match is found
    },

    updateModelInfo(firstalt) {
      this.modelInfo = this.getModelInfo(firstalt);
    },

    //---- IF DEL DIA RELATIVE UPDATE THE LINK
    updateDDrelative() {
      if (this.product.title.includes('Allpa 28')) {
        this.ddRelativeLink = '/products/allpa-28l-del-dia-travel-pack';
      } else if (this.product.title.includes('Allpa 35')) {
        this.ddRelativeLink = '/products/allpa-35l-travel-pack-del-dia';
      } else if (this.product.title.includes('Allpa 42')) {
        this.ddRelativeLink = '/products/allpa-42l-travel-pack-del-dia';
      } else if (this.product.title.includes('Gear Hauler')) {
        this.ddRelativeLink = '/products/allpa-60l-gear-hauler-tote-del-dia';
      } else if (this.product.title.includes('Todo Convertible')) {
        this.ddRelativeLink = '/products/todo-convertible-16l-tote-del-dia';
      } else {
        this.ddRelativeLink = '';
      }
    },

    //---- ADD TO CART
    addToCart() {
      // add the selected variant and quantity
      //CartJS.addItem(this.pickedID, this.quantity);
      //no quantity on this template, so we will always add 1.
      if (this.selectedVariant.status === 'Final Sale') {
        vueSideCart.addItem(this.selectedVariantID, 1, {
          finalSale: 'FINAL SALE: This item cannot be returned or exchanged.',
          _saleStatus: this.selectedVariant.status,
        });
      } else {
        vueSideCart.addItem(this.selectedVariantID, 1, {
          _saleStatus: this.selectedVariant.status,
        });
      }
      this.dynamicYieldaddToCartEvent(this.selectedVariant);

      //open the side cart after a brief delay.
      // setTimeout(function () {
      //   cartOptions.openCart();
      // }, 500);
    },

    notifySubmit() {
      // Set formSubmitted to true to trigger validation
      this.formSubmitted = true;

      if (this.isFormValid) {
        // Form submission logic
        console.log('Form submitted with email:', this.email);
        console.log('Form submitted with productID:', this.selectedVariantID);

        // Get the form data
        exponea.identify(
          {
            email_id: this.email,
          },
          {
            source: 'watchdog_request',
            email: this.email,
          }
        );

        // exponea.track("consent", {
        //   action: "accept",
        //   category: "Email Marketing",
        //   valid_until: "unlimited",
        //   message: "This consent was tracked from the watchdog request"
        // });
        // exponea.track("consent", {
        //   action: "accept",
        //   category: "Stock Notifications", // Stock Notifications
        //   valid_until: "unlimited",
        //   message: "This consent was tracked from the watchdog request"
        // });

        exponea.track('watchdog_request', {
          source: 'watchdog_request',
          product_id: this.productId,
          variant_id: this.selectedVariantID,
          product_title: this.product.title,
          variant_name: this.selectedColor.name,
          variant_image: this.selectedColor.image,
          variant_url: window.location.href,
        });

        // Set submitted to true to display success message
        this.validSubmit = true;
      } else {
        // Handle form submission when invalid
        console.log('Form submission blocked due to validation errors.');
      }
    },
    validateEmail() {
      // Regular expression for email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!this.email) {
        this.emailError = 'Email is required.';
      } else if (!emailRegex.test(this.email)) {
        this.emailError = 'Invalid email format.';
      } else {
        this.emailError = '';
      }
    },

    // GET THE PRODUCT DATA
    getProductData() {
      // let visibilityParam = new URL(window.location.href).searchParams.get(
      //   'visibility'
      // );
      let targetdomain = window.location.hostname.includes(
        'development.cotopaxi.com'
      )
        ? 'https://development-access-api.cotopaxi.com'
        : 'https://production-access-api.cotopaxi.com';

      axios
        // if visiblity param is provided, call the API with that attached.
        //TODO: make sure that this will work for all products being both Sale and Full price.
        .get(
          targetdomain +
            `/product/getProductForStorefrontByProductId/${this.productId}`
        )
        .then((response) => {
          //           if (typeof response.data.shopifyProductId === 'undefined') {
          //             //only do this toggle once, otherwise it would be infinite.
          //             if (this.initialLoadError === false) {
          //               this.initialLoadError = true;
          //               //change the URL to have the opposite visibility (fp/sale)
          //               let params = new URLSearchParams(location.search);
          //               // if (visibilityParam === 'sale') {
          //               //   params.delete('visibility');
          //               // } else {
          //               //   params.set('visibility', 'sale');
          //               // }
          //
          //               window.history.replaceState(
          //                 {},
          //                 '',
          //                 `${location.pathname}?${params}`
          //               );
          //               this.getProductData();
          //               return;
          //             }
          //           }
          this.product = response.data;

          // handle copy sections
          const sections = response.data.sections;

          // set whyYoullLoveIt and accordion data
          if (sections.whyYoullLoveIt) {
            // hardcode version to be 'a' per ecomm team
            // TODO: reformat this endpoint to remove a/b options
            this.whyYoullLoveIt = sections.whyYoullLoveIt['a'];
          }
          if (sections.detailAccordion) {
            this.accordionContent = sections.detailAccordion['a'];
          }

          //optimize cloudinary walk-in video
          if (this.product.walkInVideo) {
            this.product.walkInVideo.videoUrl =
              this.addVideoOptimizationTransforms(
                this.product.walkInVideo.videoUrl,
                800
              );
          }

          // handle any product errors from livewire and show error template
          if (
            this.product.hasOwnProperty('Status') &&
            this.product.Status.includes('Error')
          ) {
            this.error = true;
            this.loading = false;
          }

          //hide certain page elements if product is donation or gift card
          if (
            this.product.productType === 'Donation' ||
            this.product.productType === 'Gift Card'
          ) {
            this.isDonationOrGiftCard = true;
            this.hideSizeGuide = true;
          }
          //need to know gift card specifically to add chat button for gift card balance
          if (this.product.productType === 'Gift Card') {
            this.isGiftCard = true;
          }
          //hide size guide on any one sized products
          if (
            this.product.title.toLowerCase().includes('pack') ||
            this.product.title.toLowerCase().includes('bag') ||
            this.product.title.toLowerCase().includes('del dia') ||
            this.product.title.toLowerCase().includes('cada dia') ||
            this.product.title.toLowerCase().includes('tote') ||
            this.product.title.toLowerCase().includes('sling') ||
            this.product.title.toLowerCase().includes('dopp')
          ) {
            this.hideSizeGuide = true;
          }

          console.log('checking what is running');

          //loop through the different color objects
          for (const property in this.product.colorwayGroups) {
            let productGroupColorways = this.processColorways(
              this.product.colorwayGroups[property]
            );
            this.colorwaysWithInventory = [
              ...this.colorwaysWithInventory,
              ...productGroupColorways,
            ];
          }

          //use mixin to filter out OOS colorways and generate swatches
          this.colorwaysCurrentWithInventory = this.processColorways(
            this.product.colorwayGroups.currentColorways
          );
          this.colorwaysCarryoverWithInventory = this.processColorways(
            this.product.colorwayGroups.carryoverColorways
          );
          this.colorwaysSaleWithInventory = this.processColorways(
            this.product.colorwayGroups.saleColorways
          );
          this.colorwaysFinalSaleWithInventory = this.processColorways(
            this.product.colorwayGroups.finalSaleColorways
          );

          //show products without availability but are able to puchase on backorder
          this.adjustBackOrder(this.colorwaysWithInventory);

          //set the color and size on first load
          if (this.colorwaysWithInventory.length > 0) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);

            //sort sizes on all variants
            this.colorwaysWithInventory.forEach((colorway) => {
              this.sortSizeArray(colorway);
            });

            //if variant id is provided, set based on that.
            let validUrlVariantFound = false;

            if (urlParams.has('variant')) {
              let urlVariantId = urlParams.get('variant');
              var variant = this.product.variants.find(
                (variant) => variant.shopifyVariantId === urlVariantId
              );
              if (variant) {
                //check if undefined
                this.selectedColor = this.colorwaysWithInventory.find(
                  (c) => c.name === variant.colorName
                );
                if (this.selectedColor) {
                  validUrlVariantFound = true;
                  //set size based on variantID from URL + the color already found from the URL ID
                  this.selectedSize = this.selectedColor.sizes.find(
                    (s) => s.name === variant.size
                  );
                  //if not available in the size provided or the variantID in the URL, then do first available instead.
                  if (!this.selectedSize || this.selectedSize.available < 1) {
                    this.selectedSize =
                      this.returnFirstSizeWithAvailableInventory(
                        this.selectedColor.sizes
                      );
                  }
                  this.selectedVariantID = variant.shopifyVariantId;
                  this.selectedVariant = variant;

                  //set the colorway group on initial page load
                  this.setColorwayGroup();
                }
              }
            }

            //if no variant provided, or if variant ID wasn't found in available colors.
            if (!validUrlVariantFound) {
              if (urlParams.has('colorway')) {
                this.selectedColor = this.getColorwayFromUrl();

                this.setColorwayGroup();
              } else {
                // make the first color (and size) the selected variant when variant isn't provided.
                this.selectedColor = this.colorwaysWithInventory[0];
                this.selectedGroup = 0;
              }
              this.selectedSize = this.returnFirstSizeWithAvailableInventory(
                this.selectedColor.sizes
              );

              // set selectedVariantId
              this.selectedVariantID = this.selectedSize.shopifyVariantId;
              this.selectedVariant = {
                shopifyProductId: this.productId,
                sku: this.selectedSize.sku,
                title: this.selectedSize.title,
                shopifyVariantId: this.selectedSize.shopifyVariantId,
                barcode: this.selectedSize.barcode,
                price: this.selectedSize.price,
                colorName: this.selectedSize.colorName,
                size: this.selectedSize.name,
                inventoryCount: this.selectedSize.available,
                status: this.selectedColor.status,
              };

              this.updateUrl();
            }
            this.getSelectedVariantPrice();
          } else {
            //if no colorways with inventory
            // if there are no products with inventory, we will make the first variant ID the selected variant ID.
            // this will allow back in stock notifications to function on del dia products.
            if (this.product.variants.length > 0) {
              this.selectedVariantID =
                this.product.variants[0].shopifyVariantId;
            }
          }

          if (this.selectedColor.images) {
            this.updateModelInfo(this.selectedColor.images[0].alt);
          }

          this.updateDDrelative();
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          if (window.location.href.includes('?')) {
            window.location.replace(window.location.href + '&view=default');
          } else {
            window.location.replace(window.location.href + '?view=default');
          }
        });
    },
    // sortSizeArray(selectedColor) {
    //   if (selectedColor.sizes && selectedColor.sizes.length > 1) {
    //     selectedColor.sizes.sort((a, b) => {
    //       return (
    //         this.sizeToNumberConverter(a.slug) -
    //         this.sizeToNumberConverter(b.slug)
    //       );
    //     });
    //   }
    // },
    //updates the locally product locator widget to the newly selected barcode whenever a new variant is selected.
    // configLocallyPL(barcode) {
    //   const el = document.createElement('script');
    //   el.setAttribute('id', 'lcly-script-0');
    //   document.getElementsByTagName('head')[0].appendChild(el);
    //   var lcly_config_0 = {
    //     company_name: 'Cotopaxi',
    //     button_text: 'Find it Locally',
    //     button_id: 'HTML',
    //     company_id: '11290',
    //     css: '4',
    //     always_hide_button: '1',
    //     upc: barcode,
    //     n_related_styles: '3',
    //     lang: 'en-us',
    //     show_dealers: '1',
    //     n_dealers: '3',
    //     category: 'brandstore',
    //     no_link: '1',
    //     link_opens_modal: '1',
    //   };
    //   var lcly_query_0 = Object.keys(lcly_config_0)
    //     .reduce(function (a, k) {
    //       a.push(
    //         encodeURIComponent(k) + '=' + encodeURIComponent(lcly_config_0[k])
    //       );
    //       return a;
    //     }, [])
    //     .join('&');
    //   var lcly_endpoint_0 =
    //     'https://cotopaxi.locally.com/stores/map.js?' + lcly_query_0;
    //   document.getElementById('lcly-script-0').src = lcly_endpoint_0;
    // },

    // sizeToNumberConverter(sizeSlug) {
    //   switch (sizeSlug.toLowerCase()) {
    //     case 'xxs':
    //       return 1;
    //       break;
    //     case 'xs':
    //       return 2;
    //       break;
    //     case 's':
    //       return 3;
    //       break;
    //     case 'm':
    //       return 4;
    //       break;
    //     case 'l':
    //       return 5;
    //       break;
    //     case 'xl':
    //       return 6;
    //       break;
    //     case 'xxl':
    //       return 7;
    //       break;
    //     case 'xxxl':
    //       return 8;
    //       break;
    //     case '1X':
    //       return 9;
    //       break;
    //     case '2X':
    //       return 10;
    //       break;
    //     case '3X':
    //       return 11;
    //       break;
    //     case '4X':
    //       return 12;
    //       break;
    //     default:
    //       return 13;
    //       break;
    //   }
    // },

    // get bottom line info (total ratings, rating distribution, etc.)
    getBottomLine() {
      axios
        .get(
          `https://production-access-api.cotopaxi.com/yotpo/bottomLine/${this.productIdForReviews}`
        )
        .then((res) => {
          if (res.data.bottomline) {
            // set average score
            this.avgReview =
              Math.round(Number(res.data.bottomline.average_score * 10)) / 10;

            this.numReviews = Number(res.data.bottomline.total_review);
          }
        })
        .catch((err) => {
          this.error = true;
          console.error(err);
        });
    },

    // get any active discounts for displaying the content well
    getDiscountData() {
      axios
        .get(
          `https://production-access-api.cotopaxi.com/discount/getContentWellByShopifyProductId/${this.productId}`
        )
        .then((response) => {
          if (response.data.contentWell) {
            this.uptContentWell = response.data.contentWell;
            this.uptHandle = response.data.handle || '';
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // format price
    formatPrice(price) {
      let currency = '$';
      //convert to string if the data supplied isn't a string.
      if (typeof price != 'string') {
        price = price.toString(); // will return a whole number if no decimal is present.
      }

      if (price.includes('.')) {
        // if we have decimal data, make sure it is 2 decimal places deep
        price = parseFloat(price).toFixed(2).toString();
        price = price.replace('.00', '');
        // let strippedPrice = price.substr(price.length - 3)
        // if (strippedPrice === '.00'){
        // 	price
        // }
      }
      //added the turnary operator at the end for an EU legal requirement. #excludes adding this extra text to gift-cards 10/12/2020
      return `${currency}${price}`;
    },

    priceSavings(theprice, thecompare) {
      let savings = thecompare - theprice;
      return savings.toFixed(2);
    },

    //allows products to display that have no availablity but are available to purchase on back order
    adjustBackOrder(colorways) {
      colorways.forEach((color) => {
        if (color.isBackOrdered === 1) {
          color.sizes.forEach((size) => {
            size.isBackOrdered = 'true';
          });
        }
      });
    },

    //get colorway from url parameter (selected at PLP level)
    getColorwayFromUrl() {
      let urlColorwayParam = new URL(window.location.href).searchParams.get(
        'colorway'
      );
      let selectedColorway = this.colorwaysWithInventory.find(
        (color) => color.name.replace(/[^A-Z0-9]/gi, '') === urlColorwayParam
      );

      if (!selectedColorway) {
        // make the first color (and size) the selected variant when variant isn't provided.
        selectedColorway = this.colorwaysWithInventory[0];
      }

      this.selectedSize = this.returnFirstSizeWithAvailableInventory(
        selectedColorway.sizes
      );

      return selectedColorway;
    },

    setColorwayGroup() {
      if (
        this.product.colorwayGroups.currentColorways.some(
          (obj) => obj.name === this.selectedColor.name
        )
      ) {
        this.selectedGroup = 0;
      } else if (
        this.product.colorwayGroups.carryoverColorways.some(
          (obj) => obj.name === this.selectedColor.name
        )
      ) {
        this.selectedGroup = 0;
      } else if (
        this.product.colorwayGroups.saleColorways.some(
          (obj) => obj.name === this.selectedColor.name
        )
      ) {
        this.selectedGroup = 1;
      } else if (
        this.product.colorwayGroups.finalSaleColorways.some(
          (obj) => obj.name === this.selectedColor.name
        )
      ) {
        this.selectedGroup = 2;
      }
    },

    openGiftCardChat() {
      //forethought bubble is hidden by default on gift card page
      //we need to show and open the chat on gift card button click
      window.Forethought('widget', 'show');
      window.Forethought('widget', 'open');
    },
    handleOpenSibling() {
      this.isSiblingOpen = true;
    },
  },
  beforeMount() {
    this.getBottomLine();
    this.getProductData();
    this.getDiscountData();
  },
  mounted() {
    // window.addEventListener('resize', this.onResize);
    // this.onResize();
    // const script = document.createElement('script');
    // script.async = true;
    // script.src = 'https://js.klarna.com/web-sdk/v1/klarna.js';
    // script.setAttribute('data-environment', 'production');
    // script.setAttribute(
    //   'data-client-id',
    //   'klarna_live_client_UWpmalBGWlRxV2M5NGslLWtraTA5alhqVXVFRmg1OHgsMjFkYzY0ZGMtYWYyYy00ZWNlLTkzYmQtMDJhMjQ5YWVkOGMxLDEsN1ZGOEV3N0JRWThQTFRpSnVERVZYMXVTY1VHOHc0MEdBYzBKY3hBTUZoaz0'
    // );
    // document.head.appendChild(script);
  },
  updated() {
    // if (this.product.variants) {
    //   //this.configLocallyPL(this.product.variants[0].barcode);
    // }
  },
};
